(function ($){
  $(document).ready(function(){
    setInterval(function(){
    $('.collection-grid-item').each(function(){
      if($(this).find('a').hasClass('cst-sold-out')){
        $($(this)).appendTo($(this).closest('.grid-items'));
      }
    
    });
    });
  });
})(jQuery);


function toggleReadMore() {
  var readMoreLink = document.querySelector('.read-more-link');
  var readMoreContent = document.querySelectorAll('.read-more-content');
  var readMoreDots = document.querySelector('.read-more-dots');

  if (readMoreDots.style.display === "none") {
    readMoreDots.style.display = "inline";
    readMoreLink.innerHTML = "Read more";
    readMoreContent.forEach(function(content) {
      content.style.display = "none";
    });
  } else {
    readMoreDots.style.display = "none";
    readMoreLink.innerHTML = "Read less";
    readMoreContent.forEach(function(content) {
      content.style.display = "inline";
    });
  }
}
